/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Online_OnlyInputs */

const en_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch export is only available when online.`)
};

const fr_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'exportation par lots n'est disponible qu'en ligne.`)
};

const de_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Stapelexport ist nur im Online-Modus verfügbar.`)
};

const it_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esportazione in batch è disponibile solo quando si è online.`)
};

const ru_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт доступен только при подключении к интернету.`)
};

const es_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La exportación por lotes solo está disponible cuando se está en línea.`)
};

const zh_cn2_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出功能仅在联网状态下可用。`)
};

const ja_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括エクスポートは、オンライン時のみ利用可能です。`)
};

const hi_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच एक्सपोर्ट की सुविधा केवल ऑनलाइन होने पर ही उपलब्ध है।`)
};

const pt_pt2_explorer_info_batch_online_only = /** @type {(inputs: Explorer_Info_Batch_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação em lote só está disponível quando o usuário está online.`)
};

/**
* | output |
* | --- |
* | "Batch export is only available when online." |
*
* @param {Explorer_Info_Batch_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_online_only = /** @type {((inputs?: Explorer_Info_Batch_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Online_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_online_only(inputs)
	if (locale === "de") return de_explorer_info_batch_online_only(inputs)
	if (locale === "it") return it_explorer_info_batch_online_only(inputs)
	if (locale === "ru") return ru_explorer_info_batch_online_only(inputs)
	if (locale === "es") return es_explorer_info_batch_online_only(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_online_only(inputs)
	if (locale === "ja") return ja_explorer_info_batch_online_only(inputs)
	if (locale === "hi") return hi_explorer_info_batch_online_only(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_online_only(inputs)
	return en_explorer_info_batch_online_only(inputs)
});